import { FC } from "react";

import { classNames } from "@/shared/utils/classnames";

export type InputProps = JSX.IntrinsicElements["input"] & { label: string };

export const Input: FC<InputProps> = ({ className, label, ...props }) => {
  return (
    <div className="flex  flex-col">
      {label && (
        <label className="block mb-1 text-sm font-medium text-gray-700">
          {label}
        </label>
      )}

      <input
        className={classNames(
          className,
          "px-2 block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-customPurple/95 sm:text-sm sm:leading-6"
        )}
        {...props}
      />
    </div>
  );
};

export type InputWithFeedbackProps = InputProps & {
  feedback: string;
};

export const InputWithFeedback: FC<InputWithFeedbackProps> = ({
  feedback,
  ...props
}) => {
  return (
    <div>
      <Input {...props} />
      <small>{feedback}</small>
    </div>
  );
};
